import GetOrganisationForUserRequestModelBase from '../_generated/modelBases/get-organisation-for-user-request-model-base';

export default class GetOrganisationForUserRequestModel extends GetOrganisationForUserRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
